<template>
    <div id="app">
        
        <div id="main">
            <router-view :client-id="clientId" />
        </div>
    </div>
    <div class="footer">
        
        <center>Copyright Moresi.com SA 2024</center>
    </div>
</template>

<script>
import uuidv4 from 'uuid/v4'
import constants from './lib/constants'

export default {
  data() {
    return {
      clientId: uuidv4(),
      title: constants.title
    }
  }
}
</script>

<style>
body {
  margin: 0px;
  padding: 10px;
}

#app {
  font-family: Arial, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
}


#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav h1 a {
  text-decoration: none;
  padding-top: 6px;
}

#main {
  margin-top: 5px;
}

button {
  padding: 12px;
  border-radius: 8px;
  width: 200px;
  font-size: 16px;
}

input[type=text], input[type=password], select {
  padding: 0px;
  margin: 12px;
  border-radius: 8px;
  height: 48px;
  width: 200px;
  font-size: 18px;
  text-align: center;
}


</style>
